import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IPriceWidget } from "@models/entity-models";

@Kbo(CToken.PriceWidget)
export class PriceWidget extends UiObject implements IPriceWidget {

    constructor(kom: KbObjectManager) {
        super(kom);
    }    

    public showDetails: boolean;
}
